/**
 * Decide where Support Mode handoff should hard-navigate after saving session.
 */
import { CLIENT_SUPPORT_HUB_PATH } from "../supportHubPaths";

export function resolveSupportModeLandingPath(session) {
  if (!session || typeof session !== "object") return "/app";
  const openTicket = String(
    session.openSupportTicketId || session.supportTicketId || "",
  ).trim();
  const targetPath = String(session.targetPath || "").trim();
  if (
    targetPath === CLIENT_SUPPORT_HUB_PATH ||
    targetPath === "/master-account/support" ||
    (session.impersonateIntoCase && openTicket) ||
    (session.preserveSupportCaseStatus && openTicket)
  ) {
    return CLIENT_SUPPORT_HUB_PATH;
  }
  const brandId = session.brandId ? String(session.brandId).trim() : "";
  const brandName = session.brandName ? String(session.brandName).trim() : "";
  if (brandId && brandName) return "/master-account/locations";
  return "/app";
}
